<template>
	<div class="conditions-group flex-space-between--center">
		<div class="condition-editor">
			<div class="display-flex">
				<div class="column-name">
					<ConditionSourceParamType :param="sourceParamType" v-bind="componentProps" v-on="componentListeners" :items="tableItems" />
				</div>
				<div class="and px-4">And</div>
				<div class="value-input">
					<ConditionSourceParamType
						:param="valueParamType"
						v-bind="{ ...componentProps, sourceOfList: itemsTwoSourceOfList }"
						v-on="componentListeners"
						:items="tableTwoItems"
					/>
				</div>
			</div>
			<div class="condition-selector-container" :class="{ [getSingularClassName(conditionGroupId)]: true }">
				<div class="condition-selector">
					<AppSelect
						item-value="operator"
						item-text="displayText"
						:attach="`.condition-selector-container.${getSingularClassName(conditionGroupId)}`"
						naked
						v-model="condition"
						:items="selectConditionOptions"
						return-object
						@change="onChange"
					/>
				</div>
			</div>
		</div>
		<div class="remove-btn" v-show="canRemove">
			<RemoveIcon class="remove-icon" @click="$emit('removeOption', conditionGroupId)" />
		</div>
	</div>
</template>

<script>
import ConditionSourceParamType from '../../../BlockEditorParams/ParamTypes/RulesParams/ConditionSourceParamType';
import { PREVIOUS_STEP_TABLE_OUTPUT } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const';
import RemoveIcon from '../../../../BlockEditorWidget/assets/icon-remove-option.svg';
import ConditionEditorMixin from './ConditionEditorMixin';
import { ConditionValueTypes } from '@ply-io/conditions';
export default {
	name: 'JoinConditionEditor',
	mixins: [ConditionEditorMixin],
	props: {
		itemsTwo: { type: Array },
		itemsTwoSourceOfList: { type: String },
	},
	components: {
		ConditionSourceParamType,
		RemoveIcon,
	},
	computed: {
		tableTwoItems() {
			return this.itemsTwo;
		},
		selectConditionOptions() {
			return this.param.conditions.map((x) => this.getConditionOperator(x.value, x.text, x.valuesCount));
		},
	},
	methods: {
		onConditionValueTypeChange() {
			const toUpdate = { ...this.conditionGroup, ...{ conditionValueType: this.conditionValueType } };
			Object.assign(this.conditionGroup, toUpdate);
			this.onChange();
		},
		updateConditionTab(val) {
			this.conditionValueTypeEnabled = val === PREVIOUS_STEP_TABLE_OUTPUT;
		},
	},
	watch: {},
	mounted() {
		this.conditionValueType = this.conditionGroup?.conditionValueType || ConditionValueTypes.SingleItem;
	},
	data: () => ({
		conditionValueType: ConditionValueTypes.SingleItem,
		conditionValueTypeEnabled: true,
	}),
};
</script>

<style scoped lang="scss">
@import './condition-editor.scss';
.conditions-group {
	.condition-editor {
		::v-deep {
			.ProseMirror {
				padding-right: 0px;
			}
		}
		.and {
			font-size: small;
			padding-top: 10px;
			border-bottom: 1px solid var(--border-color);
		}
		.column-name,
		.value-input {
			::v-deep {
				.rich-text-box {
					width: 140px;
				}
			}
			border-bottom: 1px solid var(--border-color);
			border-bottom-right-radius: 0px;
		}
		.column-name {
			border-top-right-radius: 0px;
			border-right: 1px solid var(--border-color);
		}
		.value-input {
			border-left: 1px solid var(--border-color);
		}
		.condition-selector-container {
			.condition-selector {
				width: 100%;
				max-width: none;
				border-right: none;
				::v-deep {
					.v-input {
						width: 100%;
					}
				}
			}
		}
	}
}
</style>
